import { FormattedMessage } from 'react-intl';

import styles from './LinkBankAccount.module.css';
import LinkBankAccountForm from './LinkBankAccountForm';

const LinkBankAccount = ({ showTitle = true }) => {
    return (
        <div className={styles.LinkBankAccount}>
            {showTitle && (
                <div className={styles.title}>
                    <FormattedMessage
                        id="_.modal.link_bank_account.title"
                        defaultMessage="Business bank details"
                    />
                </div>
            )}
            <div className={styles.content}>
                <div className={styles.description}>
                    <FormattedMessage
                        id="_.modal.link_bank_account.description"
                        defaultMessage="This is where we'll send your funds. This must be your main business account, a personal account will not be funded."
                    />
                </div>
                <LinkBankAccountForm />
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default LinkBankAccount;
